import UrlUtil from '@/util/UrlUtil';
import AppUtil from '@/util/AppUtil';
import wx from 'weixin-js-sdk';
import AppVo from '@/vo/AppVo';
/**微信相关方法*/
export default class WxUtil {
    // static APPID = "wx95ef041acc227602";
    /**是否已经实例化微信 */
    static initWx: boolean = false;

    /**封装微信登录接口 snsapi_base静默授权，snsapi_userinfo弹出授权页面*/
    static wxLogin(scope = "snsapi_userinfo") {
        console.log('wxLogin');
        
        // let redirect_uri = encodeURIComponent("https://dymy888.cn/33/");
        let redirect_uri = encodeURIComponent(window.location.href);

        let appid = UrlUtil.getUrlParam("appid") || AppVo.getInstance().appid || localStorage.getItem("appid");
        if (appid) {
            localStorage.setItem("appid", appid);
            // localStorage.setItem("redirect_uri",window.location.href);
        }
        window.location.href =
            `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}&state=STATUS#wechat_redirect`
    }
    // static function get_wxsdk(params:type) {

    // } 
    /**获取微信jssdk */
    static async get_wx() {
        if (!this.initWx) {
            await this.init_wx(wx);
        }

        return wx;
    }
    static init_wx(wx: any) {
        return new Promise(resolve => {


            AppUtil.request({
                url: "/zhPay/wxpay/wxH5Share",
                method: "post",
                data: { url: window.location.href.split('#')[0], tenantId: localStorage.getItem("tenantId")}
            }, (res: any) => {
                console.log("wxUtil init_wx", res);


                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: res.data.appId, // 必填，公众号的唯一标识
                    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                    signature: res.data.signature,// 必填，签名
                    // jsApiList: ["chooseWXPay","getLocation","openLocation","scanQRCode","onMenuShareTimeline","onMenuShareAppMessage"]
                    jsApiList: ["chooseWXPay", "getLocation", "openLocation", "scanQRCode", "onMenuShareTimeline", "onMenuShareAppMessage", "updateAppMessageShareData", "updateTimelineShareData"] // 必填，需要使用的JS接口列表
                });
                this.initWx = true;
                resolve(wx);
                // console.log("首页门店信息",res);
                // this.tenantInfo.setData(res.data) ;
            });
        })
    }
}
